var map = {
	"./activity_1.svg": 974,
	"./activity_16.svg": 2428,
	"./activity_22.svg": 5285,
	"./activity_23.svg": 4116,
	"./activity_26.svg": 5945,
	"./activity_30.svg": 9764,
	"./activity_4.svg": 9155,
	"./activity_5.svg": 1778,
	"./activity_51.svg": 1327,
	"./activity_6.svg": 2529,
	"./activity_6a.svg": 1906,
	"./activity_6b.svg": 5041,
	"./activity_9.svg": 1350
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7531;